import EfEmarsysEmail from '@elem/ui/ef-emarsys-email';
import EfTitle from '@elem/ui/ef-title';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import moment from 'moment';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';

export default function TheComp() {
    const { t } = useLang('theProduct.ListA2');
    const { locale } = getLocal();
    const { pageType } = useProductStore();
    const { getSystemTime } = useGlobal();
    const systemTime = getSystemTime();

    // au 只有 TM 款
    const contactListId: any = {
        [PAGE_TYPE.BASE]: {
            us: ['579298818'],
            ca: ['579298818'],
        },
        [PAGE_TYPE.MOTOR]: {
            us: ['706505477'],
            ca: ['706505477'],
            au: ['42132085'],
        },
    };
    const date = moment(systemTime).format('YYYY-MM-DD');
    const fieldData: any = {
        [PAGE_TYPE.BASE]: {
            us: [
                {
                    id: '7979',
                    type: 'multiple',
                    value: [15],
                    overwrite: false,
                },
                {
                    id: '4423',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '11632',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
            ca: [
                {
                    id: '7979',
                    type: 'multiple',
                    value: [15],
                    overwrite: false,
                },
                {
                    id: '4424',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '11632',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
        },
        [PAGE_TYPE.MOTOR]: {
            us: [
                {
                    id: '7979',
                    type: 'multiple',
                    value: [16],
                    overwrite: false,
                },
                {
                    id: '4423',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '11632',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
            ca: [
                {
                    id: '7979',
                    type: 'multiple',
                    value: [16],
                    overwrite: false,
                },
                {
                    id: '4424',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '11632',
                    type: 'text',
                    value: date,
                    overwrite: false,
                },
            ],
            au: [
                {
                    id: '11571',
                    type: 'multiple',
                    value: [4],
                    overwrite: false,
                },
                {
                    id: '4433',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                {
                    id: '9617',
                    type: 'text',
                    value: date,
                    overwrite: true,
                },
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
            ],
        },
    };

    return (
        <div className={styles.TheComp}>
            <EfTitle theme={pageType === PAGE_TYPE.BASE ? 'black' : 'white'}>{t('title')}</EfTitle>
            <div className="ef-container">
                <div className={`ListA2-in ${pageType}`}>
                    <div className="ListA2-email">
                        <div className="ListA2-desc">{t('desc')}</div>
                        <EfEmarsysEmail
                            theme={pageType === PAGE_TYPE.BASE ? 'black' : 'white'}
                            contactListId={contactListId[pageType]?.[locale]}
                            needTerms={true}
                            fields={fieldData[pageType]?.[locale]}
                            tipsObj={{ btnText: t('btnText'), placeholder: t('placeholder'), successTips: t('successTips') }}
                            isMulti
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
